import { render } from "./ContactoPage.vue?vue&type=template&id=0c09057b"
import script from "./ContactoPage.vue?vue&type=script&lang=js"
export * from "./ContactoPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__